import { DateTime } from "luxon";
import { Person } from "./Person";

// TODO: this needs an overhaul
export const getStringDate = (date: Date | string): string | undefined => {
  if (!date) return null;
  if (typeof date === "string") return date;
  const month =
    date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();

  return `${date.getFullYear()}-${month}-${day}`;
};

export const toISODate = (date: Date) => {
  if (!date) return;
  return DateTime.fromJSDate(date).toISODate() || undefined;
};

export const toJSDate = (date: string | undefined) => {
  if (!date) return;
  return DateTime.fromISO(date).toJSDate() || null;
};

export const toISODateTime = (date: Date) => {
  if (!date) return;
  return DateTime.fromJSDate(date).toISO() || undefined;
};
